<template>
  <div class="enquete-float">
    <div class="enquete-float__close">
      <button class="enquete-float__close-link" @click="hidePopup">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="enquete-float__inner">
      <p class="enquete-float__title">
        <i class="material-icons text--primary">assignment</i
        ><slot name="title"></slot>
      </p>
      <p class="enquete-float__description"><slot name="text"></slot></p>
      <div class="text-center">
        <a
          class="button button--primary button--md button--full-sp enquete-float__button"
          target="_blank"
          rel="noopener"
          :href="linkUrl"
          @click="hidePopup"
          ><slot name="linkText"></slot
          ><i class="material-icons">chevron_right</i></a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyPopup',
  props: {
    linkUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    hidePopup() {
      this.$emit('close');
    }
  }
};
</script>
